export const useTeleportTarget = (fallback: string = 'body') => {
  const currentElement = ref<HTMLElement | null>(null)
  
  const findTeleportTarget = (element: HTMLElement | null): HTMLElement | string => {
    if (!element) return fallback
    
    // Look for parent with specific class or attribute
    let parent = element.closest('[data-teleport-container]')
    
    if (parent instanceof HTMLElement) {
      // Ensure the container has relative positioning for absolute children
      if (getComputedStyle(parent).position === 'static') {
        parent.style.position = 'relative'
      }
      return parent
    }
    
    // Fallback to immediate parent container
    parent = element.closest('.teleport-container')
    
    if (parent instanceof HTMLElement) {
      // Ensure the container has relative positioning for absolute children
      if (getComputedStyle(parent).position === 'static') {
        parent.style.position = 'relative'
      }
      return parent
    }
    
    // Ultimate fallback
    return fallback
  }
  
  const setCurrentElement = (el: HTMLElement | null) => {
    currentElement.value = el
  }
  
  const teleportTarget = computed(() => {
    return findTeleportTarget(currentElement.value)
  })
  
  return {
    setCurrentElement,
    teleportTarget
  }
}
